import { component } from 'picoapp';
import app from 'app';
import loader from 'lib/loader';
import updateProgress from 'pages/collection/update-progress';
import updateShowingCount from 'pages/collection/update-showing-count';
import updateProducts from 'pages/collection/update-products';
import updatePaginationCount from 'pages/collection/update-pagination-count';
import updateProgressWrapper from 'pages/collection/update-progress-wrapper';

const collection = component((node) => {
  let prevWrapper = node.querySelector('[data-prev-wrapper]');
  let prevBtn = node.querySelector('[data-prev-btn]');
  let nextWrapper = node.querySelector('[data-next-wrapper]');
  let nextBtn = node.querySelector('[data-next-btn]');
  const progressBar = node.querySelector('[data-pagination-progress]');

  // Update progressbar on load
  updateProgress(progressBar);

  const fetchMarkup = (urlPath, context) => {
    fetch(urlPath)
      .then((response) => response.text())
      .then((responseText) => {
        // Update products
        updateProducts(node, responseText, context);

        // Update showing count
        updateShowingCount(responseText);

        // Update pagination count
        updatePaginationCount(node, responseText);

        // Update progress
        updateProgressWrapper(node, responseText);

        // When clicking on "load previous"
        if (prevWrapper) {
          const newPrevHtml = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector('[data-prev-wrapper]')?.innerHTML;
          if (newPrevHtml) {
            prevWrapper = node.querySelector('[data-prev-wrapper]');
            prevWrapper.innerHTML = newPrevHtml;
            prevBtn = prevWrapper.querySelector('[data-prev-btn]');
            prevBtn.addEventListener('click', (e) => {
              e.preventDefault();
              prevBtn.innerHTML = loader();
              const url = prevBtn.getAttribute('href');
              fetchMarkup(url, 'prev');
            });
          } else {
            prevWrapper.classList.add('hidden');
          }
        }

        // When clicking on "load more/next"
        const newNextHtml = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('[data-next-wrapper]')?.innerHTML;
        if (newNextHtml) {
          nextWrapper = node.querySelector('[data-next-wrapper]');
          nextWrapper.innerHTML = newNextHtml;
          nextBtn = nextWrapper.querySelector('[data-next-btn]');
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            nextBtn.innerHTML = loader();
            const url = nextBtn.getAttribute('href');
            fetchMarkup(url, 'next');
          });
        } else {
          nextWrapper.classList.add('hidden');
        }

        // Update the url
        window.history.pushState({}, '', urlPath);
      });
  };

  // Eventlisteners to be added on load
  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      prevBtn.innerHTML = loader();
      const url = prevBtn.getAttribute('href');
      fetchMarkup(url, 'prev');
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      nextBtn.innerHTML = loader();
      const url = nextBtn.getAttribute('href');
      fetchMarkup(url, 'next');
    });
  }
});

app.add({ collection });
app.mount();

// This is for remounting components when changing products pr page
document.addEventListener('theme:loading:end', () => {
  app.mount();
});
